import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import { ENABLE_AUTHENTICATION_STEPS } from "../../../types";

interface TitleProps {
  step: ENABLE_AUTHENTICATION_STEPS;
}

const Title = ({ step }: TitleProps) => {
  const { t } = useTranslation();

  const renderText = () => {
    switch (step) {
      case ENABLE_AUTHENTICATION_STEPS.GetSecretKey:
      case ENABLE_AUTHENTICATION_STEPS.SendOtpCode:
        return t("Security##2FA##title##authentication app");
      case ENABLE_AUTHENTICATION_STEPS.GetEmailCode:
      case ENABLE_AUTHENTICATION_STEPS.SendEmailCode:
        return t("Security##2FA##title##authentication email");
      case ENABLE_AUTHENTICATION_STEPS.SuccessMessage:
        return t("Security##2FA##title##is enabled");
      default:
        return t("Security##2FA##title##protect your account");
    }
  };

  return (
    <Typography variant="h6" sx={{ color: colors.textDark, marginTop: "8px" }}>
      {renderText()}
    </Typography>
  );
};

export { Title };
